/**
 * Utility for sharing fasting progress and milestones
 */
export const shareProgress = async ({ title, text, url = window.location.origin }) => {
  if (navigator.share) {
    try {
      await navigator.share({
        title: title || 'KetoMachine Progress',
        text: text,
        url: url,
      });
      return true;
    } catch (error) {
      console.log('Error sharing:', error);
      return false;
    }
  } else {
    // Fallback: Copy to clipboard
    try {
      await navigator.clipboard.writeText(`${text} ${url}`);
      alert('Progress copied to clipboard!');
      return true;
    } catch (err) {
      return false;
    }
  }
};

export const generateFastingText = (elapsedHours, protocol) => {
  return `I'm ${elapsedHours.toFixed(1)}h into my ${protocol} fast on KetoMachine! ⚡️ Building metabolic flexibility one hour at a time. #KetoMachine #Fasting`;
};

export const generateMilestoneText = (streak, longest) => {
  return `Just hit a ${streak} day fasting streak on KetoMachine! 🔥 My longest fast so far is ${longest.toFixed(1)}h. Feeling unstoppable! #KetoMachine #Metabolism`;
};

export const generateGoalText = (protocol) => {
  return `Just committed to a ${protocol} fasting goal on KetoMachine! 🚀 Ready to level up my health. #KetoMachine #HealthGoals`;
};